var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-snotify'),_c('transition',{attrs:{"name":"fade"}},[(_vm.load)?_c('LoadPage'):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }